import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const imageHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.image_html_label_img_media_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.image_html_placeholder_img_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
  '<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
    '<div class="dz-default dz-message">' +
      '<input type="file" class="d-none" name="uploaded-file-img" id="uploaded-file-img">' +
      '<span class="fas fa-cloud-upload-alt"></span>' +
    '</div>' +
  '</div>' +
  '<span class="text-small text-muted">' + lang.image_html_info_supported_media + '</span>' +
'</div>' +

// Adds html for delay system
delayHtml